import React, { useState, useEffect } from "react";
import Navbar from "../components/Navbar";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import OutlinedInput from "@mui/material/OutlinedInput";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import Visibility from "@mui/icons-material/Visibility";
import CircularProgress from "@mui/material/CircularProgress";
import Button from "@mui/material/Button";
import KeyIcon from "@mui/icons-material/Key";
import PersonAddAlt1Icon from "@mui/icons-material/PersonAddAlt1";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import Typography from "@mui/material/Typography";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { login } from "../store/userSilce";

// import liff from "@line/liff";

import { internalIpV4 } from "internal-ip";

// Functions
import { loginHandler, loginonMobile } from "../components/functions/user";

function PageLogin() {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [values, setValues] = useState({
    password: "",
    showPassword: false,
  });

  const queryParams = new URLSearchParams(location.search);
  const from = queryParams.get("from");
  const Dataperson = queryParams.get("data");
  const [isLoading, setIsLoading] = useState(false);

  const [ip, setIP] = useState("");

  useEffect(() => {
    getIPaddr();
  }, []);

  const getIPaddr = async () => {
    await internalIpV4()
      .then((res) => {
        setIP(res);
        console.log("IP1: ", res);
      })
      .catch((err) => {
        console.log("err get IP: ", err);
      });
  };

  const handleChange = (prop) => (event) => {
    setValues({ ...values, [prop]: event.target.value });
  };

  const handleClickShowPassword = () => {
    setValues({
      ...values,
      showPassword: !values.showPassword,
    });
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleSubmit = async (event) => {
    if (from === "PrintTestScore") {
      setIsLoading(true);
      event.preventDefault();
      const data = new FormData(event.currentTarget);
      const user = {
        email: data.get("email"),
        password: data.get("password"),
        ipadd: ip,
        mode: "mobile",
      };

      loginonMobile(user)
        .then((res) => {
          const {
            mem_rank,
            mem_fname,
            mem_lname,
            mem_email,
            pers_id,
            mem_pos,
            mem_affiliation,
            new_usagerecordid,
          } = res.data.user;
          const official_id = res.data.user.tbmemberinfos[0].official_id;

          dispatch(
            login({
              token: res.data.token,
              rank: mem_rank,
              fname: mem_fname,
              lname: mem_lname,
              email: mem_email,
              pers_id: pers_id,
              official_id: official_id,
              position: mem_pos,
              orgname: mem_affiliation,
              userRole: res.data.userRole,
              usagerecordid: new_usagerecordid,
            })
          );

          localStorage.setItem("token", res.data.token);

          toast.success("เข้าสู่ระบบสำเร็จ");
          navigate("/PagePrintTestScoreMobile", {
            state: { Dataperson: Dataperson },
          });
        })
        .catch((error) => {
          if (error.response) {
            toast.error(error.response.data.message);
            setIsLoading(false);
          }
        });
    } else if (from === "PrintTableTestList") {
      setIsLoading(true);
      event.preventDefault();
      const data = new FormData(event.currentTarget);
      const user = {
        email: data.get("email"),
        password: data.get("password"),
        ipadd: ip,
        mode: "mobile",
      };

      loginonMobile(user)
        .then((res) => {
          const {
            mem_rank,
            mem_fname,
            mem_lname,
            mem_email,
            pers_id,
            mem_pos,
            mem_affiliation,
            new_usagerecordid,
          } = res.data.user;
          const official_id = res.data.user.tbmemberinfos[0].official_id;

          dispatch(
            login({
              token: res.data.token,
              rank: mem_rank,
              fname: mem_fname,
              lname: mem_lname,
              email: mem_email,
              pers_id: pers_id,
              official_id: official_id,
              position: mem_pos,
              orgname: mem_affiliation,
              userRole: res.data.userRole,
              usagerecordid: new_usagerecordid,
            })
          );

          localStorage.setItem("token", res.data.token);

          toast.success("เข้าสู่ระบบสำเร็จ");
          navigate("/PagePrintTableTestListScoreMobile", {
            state: { Dataperson: Dataperson },
          });
        })
        .catch((error) => {
          if (error.response) {
            toast.error(error.response.data.message);
            setIsLoading(false);
          }
        });
    } else if (from === "PrintTableScore") {
      setIsLoading(true);
      event.preventDefault();
      const data = new FormData(event.currentTarget);
      const user = {
        email: data.get("email"),
        password: data.get("password"),
        ipadd: ip,
        mode: "mobile",
      };

      loginonMobile(user)
        .then((res) => {
          const {
            mem_rank,
            mem_fname,
            mem_lname,
            mem_email,
            pers_id,
            mem_pos,
            mem_affiliation,
            new_usagerecordid,
          } = res.data.user;
          const official_id = res.data.user.tbmemberinfos[0].official_id;

          dispatch(
            login({
              token: res.data.token,
              rank: mem_rank,
              fname: mem_fname,
              lname: mem_lname,
              email: mem_email,
              pers_id: pers_id,
              official_id: official_id,
              position: mem_pos,
              orgname: mem_affiliation,
              userRole: res.data.userRole,
              usagerecordid: new_usagerecordid,
            })
          );

          localStorage.setItem("token", res.data.token);

          toast.success("เข้าสู่ระบบสำเร็จ");
          navigate("/PagePrintTableScoreMobile", {
            state: { Dataperson: Dataperson },
          });
        })
        .catch((error) => {
          if (error.response) {
            toast.error(error.response.data.message);
            setIsLoading(false);
          }
        });
    } else {
      setIsLoading(true);
      event.preventDefault();
      const data = new FormData(event.currentTarget);
      const user = {
        email: data.get("email"),
        password: data.get("password"),
        ipadd: ip,
        mode: "pc",
      };

      loginHandler(user)
        .then((res) => {
          const {
            mem_rank,
            mem_fname,
            mem_lname,
            mem_email,
            pers_id,
            mem_pos,
            mem_affiliation,
            new_usagerecordid,
          } = res.data.user;
          const official_id = res.data.user.tbmemberinfos[0].official_id;

          dispatch(
            login({
              token: res.data.token,
              rank: mem_rank,
              fname: mem_fname,
              lname: mem_lname,
              email: mem_email,
              pers_id: pers_id,
              official_id: official_id,
              position: mem_pos,
              orgname: mem_affiliation,
              userRole: res.data.userRole,
              usagerecordid: new_usagerecordid,
            })
          );

          localStorage.setItem("token", res.data.token);
          toast.success("เข้าสู่ระบบสำเร็จ");
          navigate("/PageHome");
        })
        .catch((error) => {
          if (error.response) {
            toast.error(error.response.data.message);
            setIsLoading(false);
          }
        });
    }
  };

  return (
    <>
      <Navbar />
      <Box
        sx={{
          flexGrow: 1,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "100vh",
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            width: 600,
          }}
        >
          <Box sx={{ fontSize: 18, textAlign: "center", fontWeight: "bold" }}>
            ระบบการทดสอบภาษาอังกฤษของกองทัพอากาศ
            <br />
            (RTAF ENGLISH TEST)
          </Box>
          <br />
          <Box
            sx={{
              width: { lg: "100%", md: "50%", sm: "95%", xs: "95%" },
            }}
            component="form"
            onSubmit={handleSubmit}
          >
            <FormControl variant="outlined" fullWidth>
              <TextField
                label="E-mail"
                id="E-mail"
                placeholder="(ไม่ต้องใส่ @ rtaf.mi.th)"
                name="email"
                autoComplete="email"
                autoFocus
              />
              <br />
            </FormControl>

            <FormControl variant="outlined" fullWidth>
              <InputLabel htmlFor="outlined-adornment-password">
                Password
              </InputLabel>
              <OutlinedInput
                placeholder="Password"
                id="outlined-adornment-password"
                type={values.showPassword ? "text" : "password"}
                value={values.password}
                onChange={handleChange("password")}
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={handleClickShowPassword}
                      onMouseDown={handleMouseDownPassword}
                      edge="end"
                    >
                      {values.showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                }
                label="Password"
                name="password"
              />
              <br />
            </FormControl>

            <Button
              type="submit"
              variant="contained"
              fullWidth
              sx={{ mt: 3, mb: 2 }}
              startIcon={
                isLoading ? (
                  <CircularProgress size={20} color="inherit" />
                ) : (
                  <KeyIcon />
                )
              }
              disabled={isLoading}
            >
              {isLoading ? "ลงชื่อเข้าใช้..." : "เข้าสู่ระบบ"}
            </Button>
          </Box>
          <br />

          <Box
            sx={{
              width: { lg: "100%", md: "50%", sm: "95%", xs: "95%" },
            }}
          >
            <Link to="/PageRegister" style={{ textDecoration: "none" }}>
              <Button
                variant="outlined"
                startIcon={<PersonAddAlt1Icon />}
                fullWidth
              >
                ตรวจสอบข้อมูลส่วนบุคคล
              </Button>
            </Link>
          </Box>
          <br />
          <Box
            sx={{
              width: "100%",
              textAlign: "center",
            }}
          >
            <Typography
              variant="caption"
              gutterBottom
              sx={{
                display: "block",
                fontSize: { lg: "12px", md: "12px", sm: "10px", xs: "10px" },
              }}
            >
              ติดต่อสอบถาม การใช้งานระบบ หมายเลขโทรศัพท์ 26279 (02-534-6279)
            </Typography>
            <Typography
              variant="caption"
              gutterBottom
              sx={{
                display: "block",
                fontSize: { lg: "12px", md: "12px", sm: "10px", xs: "10px" },
              }}
            >
              ติดต่อสอบถาม เรื่องการทดสอบ หมายเลขโทรศัพท์ 22965 (02-534-2965),
              26276 (02-534-6276)
            </Typography>
            <Typography
              variant="caption"
              gutterBottom
              sx={{
                display: "block",
                fontSize: { lg: "12px", md: "12px", sm: "10px", xs: "10px" },
              }}
            >
              กรณีลืมรหัสรหัสผ่านอีเมล ทอ. ติดต่อ ศคพ.สอ.ทอ. ทาง Line @rtaf
            </Typography>
            <Typography
              variant="caption"
              gutterBottom
              sx={{
                display: "block",
                fontSize: { lg: "12px", md: "12px", sm: "10px", xs: "10px" },
              }}
            >
              พัฒนาโดย ศูนย์ซอฟต์แวร์กองทัพอากาศ &reg;{" "}
              {new Date().getFullYear()}
            </Typography>
          </Box>
        </Box>
      </Box>
    </>
  );
}

export default PageLogin;
